import {
  fetchDeliveryZipPermitted as fetchInner,
} from "@the-drop/customer-shared/api/compliance";

import { getCustomerApiBaseUrl } from "./api-base";

export function fetchDeliveryZipPermitted(rawZip: string) {
  return fetchInner(getCustomerApiBaseUrl(), rawZip);
}

export type { DeliveryZipCheckResult } from "@the-drop/customer-shared/api/compliance";
